import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, reaction, makeObservable, runInAction } from "mobx";
import filterOutUndefined from "../Core/filterOutUndefined";
import CatalogSearchProvider from "../Models/SearchProviders/CatalogSearchProvider";
let SearchState = (_class = class SearchState {
  constructor(options) {
    _initializerDefineProperty(this, "catalogSearchText", _descriptor, this);
    _initializerDefineProperty(this, "isWaitingToStartCatalogSearch", _descriptor2, this);
    _initializerDefineProperty(this, "locationSearchText", _descriptor3, this);
    _initializerDefineProperty(this, "isWaitingToStartLocationSearch", _descriptor4, this);
    _initializerDefineProperty(this, "unifiedSearchText", _descriptor5, this);
    _initializerDefineProperty(this, "isWaitingToStartUnifiedSearch", _descriptor6, this);
    _initializerDefineProperty(this, "showLocationSearchResults", _descriptor7, this);
    _initializerDefineProperty(this, "showMobileLocationSearch", _descriptor8, this);
    _initializerDefineProperty(this, "showMobileCatalogSearch", _descriptor9, this);
    _initializerDefineProperty(this, "locationSearchResults", _descriptor0, this);
    _initializerDefineProperty(this, "catalogSearchResults", _descriptor1, this);
    _initializerDefineProperty(this, "unifiedSearchResults", _descriptor10, this);
    _defineProperty(this, "_catalogSearchDisposer", void 0);
    _defineProperty(this, "_locationSearchDisposer", void 0);
    _defineProperty(this, "_unifiedSearchDisposer", void 0);
    _defineProperty(this, "_workbenchItemsSubscription", void 0);
    _defineProperty(this, "terria", void 0);
    makeObservable(this);
    this.terria = options.terria;
    runInAction(() => {
      this.terria.searchBarModel.catalogSearchProvider = options.catalogSearchProvider || new CatalogSearchProvider("catalog-search-provider", options.terria);
    });
    const self = this;
    this._catalogSearchDisposer = reaction(() => self.catalogSearchText, () => {
      self.isWaitingToStartCatalogSearch = true;
      if (self.catalogSearchProvider) {
        self.catalogSearchResults = self.catalogSearchProvider.search("");
      }
    });
    this._locationSearchDisposer = reaction(() => self.locationSearchText, () => {
      self.isWaitingToStartLocationSearch = true;
      self.locationSearchResults = self.locationSearchProviders.map(provider => {
        return provider.search("");
      });
    });
    this._unifiedSearchDisposer = reaction(() => this.unifiedSearchText, () => {
      this.isWaitingToStartUnifiedSearch = true;
      this.unifiedSearchResults = this.unifiedSearchProviders.map(provider => {
        return provider.search("");
      });
    });
    this._workbenchItemsSubscription = reaction(() => this.terria.workbench.items, () => {
      this.showLocationSearchResults = false;
    });
  }
  dispose() {
    this._catalogSearchDisposer();
    this._locationSearchDisposer();
    this._unifiedSearchDisposer();
    this._workbenchItemsSubscription();
  }
  get supportsAutocomplete() {
    return this.locationSearchProviders.every(provider => provider.supportsAutocomplete());
  }
  get locationSearchProviders() {
    return this.terria.searchBarModel.locationSearchProvidersArray;
  }
  get catalogSearchProvider() {
    return this.terria.searchBarModel.catalogSearchProvider;
  }
  get unifiedSearchProviders() {
    return filterOutUndefined([this.catalogSearchProvider, ...this.locationSearchProviders]);
  }
  searchCatalog() {
    if (this.isWaitingToStartCatalogSearch) {
      this.isWaitingToStartCatalogSearch = false;
      if (this.catalogSearchResults) {
        this.catalogSearchResults.isCanceled = true;
      }
      if (this.catalogSearchProvider) {
        this.catalogSearchResults = this.catalogSearchProvider.search(this.catalogSearchText);
      }
    }
  }
  setCatalogSearchText(newText) {
    this.catalogSearchText = newText;
  }
  searchLocations() {
    if (this.isWaitingToStartLocationSearch) {
      this.isWaitingToStartLocationSearch = false;
      this.locationSearchResults.forEach(results => {
        results.isCanceled = true;
      });
      this.locationSearchResults = this.locationSearchProviders.map(searchProvider => searchProvider.search(this.locationSearchText));
    }
  }
  searchUnified() {
    if (this.isWaitingToStartUnifiedSearch) {
      this.isWaitingToStartUnifiedSearch = false;
      this.unifiedSearchResults.forEach(results => {
        results.isCanceled = true;
      });
      this.unifiedSearchResults = this.unifiedSearchProviders.map(searchProvider => searchProvider.search(this.unifiedSearchText));
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "catalogSearchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isWaitingToStartCatalogSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locationSearchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isWaitingToStartLocationSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "unifiedSearchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isWaitingToStartUnifiedSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showLocationSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showMobileLocationSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showMobileCatalogSearch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "locationSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "catalogSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "unifiedSearchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "supportsAutocomplete", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "supportsAutocomplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationSearchProviders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationSearchProviders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "catalogSearchProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "catalogSearchProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unifiedSearchProviders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unifiedSearchProviders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchCatalog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchCatalog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCatalogSearchText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCatalogSearchText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchLocations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchUnified", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchUnified"), _class.prototype), _class);
export { SearchState as default };